import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "./CookieBanner.css";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("userConsent");
    if (!consent) {
      setIsVisible(true);
    } else if (consent === "accepted") {
      loadGoogleTagManager();
    }
  }, []);

  const loadGoogleTagManager = () => {
    const gtmScript = document.createElement("script");
    gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=GTM-KFRHMS6V"; 
    gtmScript.async = true;
    document.head.appendChild(gtmScript);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "gtm.js",
      "gtm.start": new Date().getTime(),
    });
  };

  const acceptCookies = () => {
    Cookies.set("userConsent", "accepted", {
      expires: 365,
      sameSite: "None",
      secure: true,
    });
    setIsVisible(false);
    loadGoogleTagManager();

    // Inform GTM about analytics consent
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "cookie_consent",
      analytics_storage: "granted",
    });
  };

  const rejectCookies = () => {
    Cookies.set("userConsent", "rejected", {
      expires: 365,
      sameSite: "None",
      secure: true,
    });
    setIsVisible(false);

    // Inform GTM about denial of analytics consent
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "cookie_consent",
      analytics_storage: "denied",
    });
  };

  return (
    isVisible && (
      <div className="cookie-banner">
        <p style={{ margin: 0 }}>
          Genom att klicka på "acceptera" samtycker du till lagring av cookies
          på din enhet för att förbättra navigeringen på webbplatsen, analysera
          webbplatsens användning och bistå i våra marknadsföringsinsatser.{" "}
          <a href="/privacy-policy">Läs mer om vår privacy policy</a>.
        </p>
        <div className="cookie-banner-buttons">
          <button onClick={rejectCookies} className="cookie-button">
            Avvisa
          </button>
          <button onClick={acceptCookies} className="cookie-button">
            Acceptera
          </button>
        </div>
      </div>
    )
  );
};

export default CookieBanner;
